import { render } from "./DropdownComponent.vue?vue&type=template&id=8f4948e0"
import script from "./DropdownComponent.vue?vue&type=script&lang=js"
export * from "./DropdownComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__